/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  ReleaseService,
  type Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto,
} from '../../services/wealthlane-award-services';
import { ReleaseFilterService } from '../../services/wealthlane-award-services/services/ReleaseFilterService';

const usePostReleaseCalculateTax = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  isSelectAllActive?: boolean,
  releaseId?: string,
  filter?: any,
  openSubmitModal?: () => void,
  setTaskReferenceNo?: any,
  onSuccessCallback?: () => void,
  onManualTaxConfirmationRequired?: (payload: any) => void,
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ payload, overwriteManualTax = false }: { payload: any; overwriteManualTax?: boolean }) => {
      const { filter: searchKeyWord, createdFromDate, createdToDate, grantName, ...restFilter } = filter || {};
      const transformedFilter = {
        ...restFilter,
        searchKeyWord: searchKeyWord,
        grantId: grantName,
        fromDate: createdFromDate,
        toDate: createdToDate,
      };
      return await handleRequest(
        isSelectAllActive
          ? ReleaseFilterService.postApiAwardApiAppReleaseFilterCalculateTaxByFilter({
            releaseId: releaseId,
            filter: transformedFilter,
            overwriteManualTax,
          })
          : ReleaseService.postApiAwardApiAppReleaseCalculateTax(payload, overwriteManualTax)
      );
    },
    {
      onSuccess: async (response: any, variables: any) => {
        if (response != null) {
          if (
            response.requiresManualTaxOverwriteConfirmation === true &&
            !variables.overwriteManualTax
          ) {
            onManualTaxConfirmationRequired?.(variables.payload);
            return;
          }
          if (response.sentToBackground === true) {
            openSubmitModal();
            setTaskReferenceNo(response.taskReferenceNo);
          } else {
            await queryClient.invalidateQueries('getReleaseIncludedList');
            toast.success(<ToastComponent label='Success' message='Tax Calculated' />);
            onSuccessCallback?.();
          }
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostReleaseCalculateTax;
